import { ReviewDetails } from '../ReviewDetails';

import { ReviewDetailsContext } from '../context/ReviewDetailsContext';

export const AuthReviewDetails = () => {
  return (
    <ReviewDetailsContext.Provider
      value={{
        mode: 'authorized',
      }}
    >
      <ReviewDetails />
    </ReviewDetailsContext.Provider>
  );
};
